import { IntegrationFormDataViewFragment } from 'generated/graphql';
import { IntegrationCardWrapper } from '../IntegrationCardWrapper';
import { DrawerIntegrationCardLeftActions } from './DrawerIntegrationCardLeftActions';
import { DrawerIntegrationCardRightActions } from './DrawerIntegrationCardRightActions';

interface AddNewIntegrationDrawerContentCardProps {
  integration: IntegrationFormDataViewFragment;
}

export const AddNewIntegrationDrawerContentCard = ({
  integration,
}: AddNewIntegrationDrawerContentCardProps) => {
  const { displayName, logo } = integration.channel;

  const oAuthURL =
    integration.__typename === 'OAuthFormData'
      ? integration.oAuthURL
      : undefined;

  return (
    <IntegrationCardWrapper
      size="small"
      name={displayName}
      logo={logo}
      leftActions={
        <DrawerIntegrationCardLeftActions
          integrationChannel={integration.channel}
        />
      }
      rightActions={
        <DrawerIntegrationCardRightActions
          integrationChannel={integration.channel}
          integrationType={integration.integrationType}
          oAuthURL={oAuthURL}
        />
      }
    />
  );
};
